import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IExhibitorInvoiceList } from "../type/exhibitorType";
import ExhibitorInvoiceTableRow from "./ExhibitorInvoiceTableRow";
const ExhibitorInvoice = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: "",
	});
	const [searchParams, setSearchParams] = useState({ name: "", status: "" });
	const { data, isLoading } = useGetQueryWithTotal<IExhibitorInvoiceList[]>({
		endPoint: "/api/admin/exhibitor/invoice",
		queryKeys: ["Exhibitor"],
		params: {
			...pagination,
			invoice_no: searchParams.name,
			status: searchParams.status,
			dateRange,
		},
	});
	return (
		<>
			<CommCard
				showSearch
				showStatus
				showCardHeader
				headerTitle={`Exhibitor Invoice List (${data?.total})`}
				handleSearchFun={(name) =>
					setSearchParams((prev) => ({ ...prev, name }))
				}
				statusOptions={[
					{ id: "Paid", name: "Paid" },
					{ id: "Unpaid", name: "Unpaid" },
					{ id: "Partial Paid", name: "Partial Paid" },
				]}
				handleSelectStatus={(status) =>
					setSearchParams((prev) => ({ ...prev, status }))
				}
				helmetTitle='BTTF - Fair member list'
				handleDateRange={(date) => {
					setDateRange(date);
				}}
				showDateRange
			>
				<TableContainer>
					<Table sx={{ position: "relative", minHeight: "250px" }}>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Date</TableCell>
								<TableCell>Invoice No.</TableCell>
								<TableCell>Company Name</TableCell>
								<TableCell>Email</TableCell>
								<TableCell>Amount</TableCell>
								<TableCell>Due</TableCell>
								<TableCell>Status</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : data?.data ? (
							<TableBody>
								{data?.data?.map((allAdmin, index) => {
									return (
										<ExhibitorInvoiceTableRow
											key={allAdmin.id}
											allAdmin={allAdmin}
											index={index}
											paginationSkip={pagination.skip}
										/>
									);
								})}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={data?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>
			</CommCard>
		</>
	);
};
export default ExhibitorInvoice;
